import { Cancel, Search } from "@mui/icons-material";
import { InputAdornment, Portal, TextField } from "@mui/material";
import { deepPurple, grey } from "@mui/material/colors";
import {
  GridPortalWrapper,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
} from "@mui/x-data-grid";
import { FC } from "react";

const sxStyles = {
  standard: {
    width: 260,
    "& .MuiInput-underline:hover:not(.Mui-disabled)::before": {
      borderBottomColor: deepPurple[800],
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: deepPurple[800],
    },
    "& .MuiInputLabel-shrink.Mui-focused": {
      color: grey[800],
    },
  },
  outlined: {
    width: "15.5rem",
    background: "white",
    "& .MuiOutlinedInput-root": { height: "2.1875rem", fontSize: "0.875rem" },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: deepPurple[800],
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: deepPurple[800],
    },
  },
};

export interface SearchBarProps {
  // "outlined" drops the floating "Search" label for a placeholder.
  variant?: "standard" | "outlined";
  placeholder?: string;
}

const SearchBar: FC<SearchBarProps> = ({
  variant = "standard",
  placeholder,
}) => {
  const container = document.getElementById("filter-panel");
  const outlined = variant === "outlined";

  return (
    <>
      <Portal container={container}>
        <GridPortalWrapper>
          <QuickFilter expanded>
            <QuickFilterControl
              render={({ ref, ...other }) => (
                <TextField
                  {...other}
                  sx={outlined ? sxStyles.outlined : sxStyles.standard}
                  inputRef={ref}
                  aria-label="Search"
                  label={outlined ? undefined : "Search"}
                  placeholder={placeholder}
                  size="small"
                  variant={variant}
                  slotProps={{
                    input: {
                      slotProps: {
                        input: outlined
                          ? undefined
                          : { sx: { marginBottom: "-0.15rem !important" } },
                      },
                      endAdornment: other.value ? (
                        <InputAdornment position="end">
                          <QuickFilterClear
                            edge="end"
                            size="small"
                            aria-label="Clear search"
                            material={{ sx: { marginRight: -0.75 } }}
                          >
                            <Cancel fontSize="small" />
                          </QuickFilterClear>
                        </InputAdornment>
                      ) : (
                        <InputAdornment position="start">
                          <Search fontSize="small" />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              )}
            />
          </QuickFilter>
        </GridPortalWrapper>
      </Portal>
    </>
  );
};

export default SearchBar;
